// extracted by css-extract-rspack-plugin
export default {"visualContainer":"Universe26BannerVisual-module__visualContainer__u2bz5","visualImage":"Universe26BannerVisual-module__visualImage__WkOdU"};